"use client";

import { useEffect } from "react";
import { useRouter } from "next/navigation";
import { createClient } from "@/lib/supabase/client";

// Handles the implicit-flow recovery case where Supabase redirects to the
// site root with #access_token=...&type=recovery in the hash. The browser
// Supabase client detects this hash and fires PASSWORD_RECOVERY, at which
// point we forward the user to the reset page.
export function PasswordRecoveryHandler() {
    const router = useRouter();

    useEffect(() => {
        const supabase = createClient();
        const { data: { subscription } } = supabase.auth.onAuthStateChange((event) => {
            if (event === "PASSWORD_RECOVERY") {
                router.push("/account/reset-password");
            }
        });
        return () => subscription.unsubscribe();
    }, [router]);

    return null;
}
